module.exports = __webpack_public_path__ + "static/b9-cb546955c0f94cb1d8f7523b453141b2.svg";